import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { UserProvider } from './UserContext';
import LoginPage from './Login/Login.js';
import Dashboard from './Dashboard/Dashboard.js';
import ListaFortotikon from './ListaFortotikon/Fortotikes.js';
import CusCard from './CusCard/CusCard.js';
import Voucher from './Tracking/Voucher.js';
import Tracking from './Tracking/Tracking.js';
import StatisticsPage from './Statistics/Statistics.js';
import Contact from './Contact/Contact.js';
import Upload from './Upload/Upload.js';
import Profile from './Profile/Profile.js';
import UploadInvoice from './UploadInvoice/UploadInvoice.js';
////import CreatePins from "./CreatePin/PinDashboard.js"
import Projects from './Projects/projects.js';
import Notes from './Notes/notes.js';
import MapWithMarkers from "./CreatePin/CreatePin2.js"
import ProtectedRoute from './ProtectedRoute';
import Loader from './Component/Loader.js';
import { useSelector } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import GoogleCalendar from './Calander/Calendar.js';
import ListaParaggelion from './ListaParaggelion/Paraggelies.js';
import WebCRM from './WebCRM/WebCRM.js';


// Disable console logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
}

function App() {
  console.log('Rendering App component');

 // Access loading state
 const isLoading = useSelector((state) => state.loading); 

 return (
  <HelmetProvider>
    <UserProvider>
      <Helmet>
        <title>Chronos - WebApp</title>
      </Helmet>
     <Router>
       <div className="App">
         {isLoading && <Loader />}
         <Routes>
          {/* Μόνο το login μένει ελεύθερο */}
          <Route path="/login" element={<LoginPage />} />

          {/* Όλες οι υπόλοιπες προστατεύονται */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/fortotikes" element={<ProtectedRoute><ListaFortotikon /></ProtectedRoute>} />
          <Route path="/tracking" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />
          <Route path="/stats" element={<ProtectedRoute><StatisticsPage /></ProtectedRoute>} />
          <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />   
          <Route path="/upload-fortotikes" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
          <Route path="/upload-invoice" element={<ProtectedRoute><UploadInvoice /></ProtectedRoute>} />
          <Route path="/pins" element={<ProtectedRoute><MapWithMarkers /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/CusCard" element={<ProtectedRoute><CusCard /></ProtectedRoute>} />
          <Route path="/Voucher" element={<ProtectedRoute><Voucher /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><GoogleCalendar /></ProtectedRoute>} />
          <Route path="/Projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
          <Route path="/Notes" element={<ProtectedRoute><Notes /></ProtectedRoute>} />
          <Route path="/paraggelies" element={<ProtectedRoute><ListaParaggelion /></ProtectedRoute>} />
          <Route path="/WebCRM" element={<ProtectedRoute><WebCRM /></ProtectedRoute>} />

          {/* Default route */}
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
       </div>
     </Router>
   </UserProvider>
  </HelmetProvider>
  );
}

export default App;
